import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { imageUrl } from "../lib/api";

// Square frame on the same ivory as the processed photos, so every product looks consistent.
export const ProductImage = ({ imageId, variant = "card", alt = "", className = "", iconSize = 64, testId }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [imageId]);
  return (
    <div className={`aspect-square bg-[#EBDFCC] flex items-center justify-center overflow-hidden ${className}`} data-testid={testId}>
      {imageId && !failed ? (
        <img src={imageUrl(imageId, variant)} alt={alt} loading="lazy" onError={() => setFailed(true)} className="w-full h-full object-contain" />
      ) : (
        <FlaskConical size={iconSize} className="text-[#C99898]/40" strokeWidth={1} />
      )}
    </div>
  );
};

export const primaryImageId = (p) => p?.images?.[0]?.id || null;
